module.exports = __webpack_public_path__ + "img/krestick.811f9cec.svg";